import { PureComponent, ReactNode } from 'react';
import AwsAmplify from 'aws-amplify';
import config from 'config';

interface AmplifyProps {
    children?: ReactNode;
}

export default class Amplify extends PureComponent<AmplifyProps> {
    constructor(props: AmplifyProps) {
        super(props);

        AwsAmplify.configure(config.aws.amplify);
    }

    render() {
        return this.props.children;
    }
}
